import UpgradeModal from './UpgradeModal'

export default UpgradeModal
